(function ($) {

    function panMap(map, bounds){
        var bodyContainer = $('body');

        if($(window).width() > 975 ){
            if(bodyContainer.hasClass('map-panned-for-desktop')){
            }else{
                if(bodyContainer.hasClass('map-panned-for-mobile')){
                    map.panBy(250, 75);
                }else{
                    map.panBy(250, 0);
                }
                bodyContainer.addClass('map-panned-for-desktop');
                bodyContainer.removeClass('map-panned-for-mobile');
            }
        }else{
            if(bodyContainer.hasClass('map-panned-for-mobile')){
            }else{
                if(bodyContainer.hasClass('map-panned-for-desktop')){
                    map.panBy(-250, -75);
                }else{
                    map.panBy(0, -75);
                }
                bodyContainer.addClass('map-panned-for-mobile');
                bodyContainer.removeClass('map-panned-for-desktop');
            }

        }
    }


    function CustomMarker(latlng, map, PARAM1, PARAM2, marker) {
        this.latlng_ = latlng;
        this.infoWindowIndex = PARAM1;
        this.mapIndex = PARAM2;
        this.setMap(map);
        this.map_ = map;
        this.undrawn_ = true;
        this.marker_ = marker;



        // Define a property to hold the image's div. We'll
        // actually create this div upon receipt of the onAdd()
        // method so we'll leave it null for now.
        this.div_ = null;

        // Explicitly call setMap on this overlay.
        this.setMap(map);
    }


    CustomMarker.prototype = new google.maps.OverlayView();
    CustomMarker.prototype.draw = function () {
        var markerInfo = $('#locationInfoMarker').html();
        var me = this;
        var div = this.div_;
        if (!div) {
            div = $(
                '<div class="pg-google-map--pin"><div class="pg-google-map--address"><p>' +
                markerInfo + 
                '</p></div>' +
                '<div class="animated-dot">' +
                '<div class="middle-dot"></div>' +
                '<div class="signal"></div>' +
                '<div class="signal2"></div>' +
                '</div></div>')[0];
            div.style.position = 'absolute';
            div.style.paddingLeft = '0px';
            div.style.cursor = 'pointer';
            var panes = this.getPanes();

            if(this.undrawn_){

                panes.overlayImage.appendChild(div);
                this.undrawn_ = false;
            }
        }


        var point = this.getProjection().fromLatLngToDivPixel(this.latlng_);

        if (point) {
            div.style.left = point.x + 'px';
            div.style.top = point.y + 'px';
        }

 
    };
    CustomMarker.prototype.remove = function () {
        this.div_.parentNode.removeChild(this.div_);
        this.div_ = null;
    };

    CustomMarker.prototype.getPosition = function () {
        return this.latlng_;
    };



    var __ = {


        new_map: function ($el) {
            var $markers = $el.find('.marker');
            var args = {
                zoom: 16,
                center: new google.maps.LatLng(0, 0),
                styles: __.style,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                disableDefaultUI: true,
                scrollwheel: false,
                draggable: false,
                streetViewControl: false,
            };
            var map = new google.maps.Map($el[0], args);
            map.markers = [];
            $markers.each(function (i) {
                __.add_marker($(this), map, i);
            });
            __.center_map(map);

            return map;
        },


        add_marker: function ($marker, map, count) {
            var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
            var overlay = new CustomMarker(latlng, map, count, 1, $marker);

            var marker = new google.maps.Marker({
                position: latlng,
                visible: false,
                map: map
            });
            map.markers.push(marker);


            if ($marker.html()) {
                var infowindow = new google.maps.InfoWindow({
                    content: $marker.html()
                });
                google.maps.event.addListener(marker, 'click', function () {
                    infowindow.open(map, marker);
                });
            }//
        },

        center_map: function (map) {
            var bounds = new google.maps.LatLngBounds();
            $.each(map.markers, function (i, marker) {
                var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                bounds.extend(latlng);
            });
            if (map.markers.length === 1) {

                var _window = $(window);
                map.setCenter(bounds.getCenter());

                panMap(map, bounds);
                // _window.on('resize',function(){
                //     panMap(map, bounds);
                // });
                
                
                map.setZoom(16);
            }
            else {
                map.fitBounds(bounds);
            }
        },

        style: [{
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#000000"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#000000"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                }
            ]
        }]
    };
    // Attach Toolbox to window //
    window._map = __;

})(jQuery); // Fully reference jQuery after this point.